import { connect } from "react-redux";
import get from "lodash/get";

import getDates from "./../services/date.service";

import {
  changeTimeLogisticReport as onChangeTimeLogisticReport,
  changeSearchTermLogisticReport as onChangeSearchTermLogisticReport,
  getControlPointsReports as onGetControlPointsReports,
  getTaskTripsReports as onGetTaskTripsReports,
  getTaskTripReport as onGetTaskTripReport,
  clearTaskTripReport as onClearTaskTripReport,
  logisticTaskTrpReportDownload as onLogisticTaskTrpReportDownload,
} from "../../actions/logisticReportsActions";

import { getLogisticTripGeoJson as onGetReportLogisticTripGeoJson } from "./../../actions/logisticTripsActions";

const getNextDate = () => {
  const date = new Date();

  return new Date(date.setDate(date.getDate() + 1));
};

const mapStateToProps = (state) => ({
  dataState: state.logisticReports.dataState,
  getControlPointsDataState: state.logisticReports.getControlPointsDataState,
  getTaskTripsReportsDataState: state.logisticReports.getTaskTripsReportsDataState,
  getTaskTripReportDataState: state.logisticReports.getTaskTripReportDataState,
  taskTripsReportGeojsonDataState: state.logisticReports.taskTripsReportGeojsonDataState,
  taskTripsReportGeojsonDataState: state.logisticReports.taskTripsReportGeojsonDataState,
  taskTripsReportDownloadDataState: state.logisticReports.taskTripsReportDownloadDataState,
  reportStartDate: get(state, ["logisticReports", "reportRangeTime", "reportStartDate"], getDates.getNullTimeDate(new Date())),
  reportEndDate: get(state, ["logisticReports", "reportRangeTime", "reportEndDate"], getNextDate()),
  reportStartTime: get(state, ["logisticReports", "reportRangeTime", "reportStartTime"], getDates.getNullTimeDate(new Date())),
  reportEndTime: get(state, ["logisticReports", "reportRangeTime", "reportEndTime"], getDates.getNullTimeDate(new Date())),
  searchTerm: get(state, ["logisticReports", "searchTerm"], null),
  controlPoints: get(state, ["logisticReports", "controlPoints"], []),
  taskTrips: get(state, ["logisticReports", "taskTrips"], []),
  taskTrip: get(state, ["logisticReports", "taskTrip"], null),
  errors: get(state, ["logisticReports", "errors"], []),
});

const mapDispatchToProps = {
  onChangeTimeLogisticReport,
  onChangeSearchTermLogisticReport,
  onGetControlPointsReports,
  onGetTaskTripsReports,
  onGetTaskTripReport,
  onGetReportLogisticTripGeoJson,
  onClearTaskTripReport,
  onLogisticTaskTrpReportDownload,
};

const withLogisticReports = (Component) => connect(mapStateToProps, mapDispatchToProps)(Component);

export { withLogisticReports };
